import React, { useState } from "react"
import { Link } from "gatsby"
import Accordion from "@material-ui/core/Accordion"
import AccordionSummary from "@material-ui/core/AccordionSummary"
import AccordionDetails from "@material-ui/core/AccordionDetails"
import ExpandMoreIcon from "@material-ui/icons/ExpandMore"
const NestedAccordion = ({ answerItem, summaryString, testimonialLink }) => {
  const [expanded, setExpanded] = useState(false)
  return (
    <Accordion
      style={{
        backgroundColor: "transparent",
        border: "none",
        boxShadow: "none",
        margin: "20px 0",
      }}
      onChange={(event, expand) => setExpanded(expand)}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panel1a-content"
        id="panel1a-header"
        style={{ borderBottom: "1px solid black" }}
      >
        <h3 style={{ fontWeight: "500" }}>
          <b>{answerItem.testimonial.name}</b>: {summaryString}
          {!expanded && (
            <i style={{ fontWeight: "500", fontSize: "1rem" }}>... read more</i>
          )}
        </h3>
      </AccordionSummary>
      <AccordionDetails>
        <p style={{ lineHeight: "200%" }}>
          <b>{answerItem.testimonial.name}</b>: {answerItem.answer_body}
          <p style={{ fontSize: "0.9rem" }}>
            Read about {answerItem.testimonial.name}
            's journey{" "}
            <Link to={testimonialLink} style={{ textDecoration: "underline" }}>
              here
            </Link>
            .
          </p>
        </p>
      </AccordionDetails>
    </Accordion>
  )
}
export default NestedAccordion
